const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div>
        <div className="footer-title-big">dYzital</div>
        <p className="footer-copy">Strategy, creative, and conversion systems built for measurable growth.</p>
        <div className="footer-nap" aria-label="Business contact details">
          <span>WorkFlo Hitex Bizness Square, Madhapur, Hyderabad - 500081</span>
          <a href="tel:+916281506590">+91 62815 06590</a>
          <a href="mailto:info@dyzital.com">info@dyzital.com</a>
        </div>
      </div>

      <div className="footer-meta">
        <span>SEO</span>
        <span>Paid Media</span>
        <span>Web</span>
        <span>CRO</span>
      </div>
    </div>
    <p className="footer-legal">
      &copy; 2026 dYzital
      <br />
      Operated by dYzitalX Software Solutions Pvt. Ltd.
    </p>
  </footer>
);

export default Footer;
